import React, { createContext, useContext, useEffect, useState } from "react";
import { apiInstance } from "../api/api";

const FinancialYearContext = createContext();

export const useFinancialYear = () => useContext(FinancialYearContext);

export const FinancialYearProvider = ({ children }) => {
  const [activeFY, setActiveFY] = useState(null);
  const [loadingFY, setLoadingFY] = useState(true);

  useEffect(() => {
    apiInstance.get("/financial-years/active/")
      .then(res => setActiveFY(res.data))
      .catch(() => setActiveFY(null))
      .finally(() => setLoadingFY(false));
  }, []);

  return (
    <FinancialYearContext.Provider
        value={{ activeFY, loadingFY }}
    >
      {children}
    </FinancialYearContext.Provider>
  );
};
